import React from 'react';
import './style.sass';

export function ModalMontoMinimo(props) {
    const {
        remvoeAction,
        awaitAction,
        title,
        subtitulo,
        body
    } = props;

    const elimiar = () => remvoeAction(true)

    const recapacitar = () => awaitAction(true)

    return (
        <>
            <div className="modalTarjetaNoAgregada">
                {title &&
                    <div className="boxTextos">
                        <h4>{title}</h4>
                    </div>
                }

                <div className="contBtnsEnterado">
                    <div className="bodyModal">
                        <p>{subtitulo}</p>
                        <p>{body}</p>
                    </div>
                    <div className="btnContinuar" onClick={remvoeAction}>Aceptar</div>
                </div>
            </div>

        </>
    )
}
export function ModalTarjeta(props) {
    const {
        remvoeAction,
        awaitAction,
        title,
        body
    } = props;

    const elimiar = () => remvoeAction(true)

    const recapacitar = () => awaitAction(true)

    return (
        <>
            <div className="modalTarjetaNoAgregada">
                {title &&
                    <div className="boxTextos">
                        <h4>{title}</h4>
                    </div>
                }

                <div className="contBtnsEnterado">
                    <div className="bodyModal">
                        <p>{body}</p>
                    </div>
                    <div className="btnContinuar" onClick={remvoeAction}>Enterado</div>
                </div>
            </div>

        </>
    )
}

export function ModalApagarTarjeta(props) {
    const {
        remvoeAction,
        awaitAction,
        title,
        body,
        subBody
    } = props;

    const elimiar = () => remvoeAction(true);

    const recapacitar = () => awaitAction(true);

    return (
        <>
            <div className="modalTarjetaNoAgregada">
                {title &&
                    <div className="boxTextos">
                        <h4>{title}</h4>
                    </div>
                }

                <div className="contBtnsEnterado">
                    <div className="bodyModal">
                        <p>{body}</p>

                        {subBody && <p>{subBody}</p>}
                    </div>

                    <div className="contBtns">
                        <div className="btnBlanco" onClick={recapacitar}>Cancelar</div>
                        <div className="btnContinuar2" onClick={elimiar}>SI, apagarla</div>
                    </div>
                </div>
            </div>

        </>
    )
}

export function ModalBorrarTarjeta(props) {
    const {
        remvoeAction,
        awaitAction,
        title,
        body,
        subBody
    } = props;

    const elimiar = () => remvoeAction(true);

    const recapacitar = () => awaitAction(true);

    return (
        <>
            <div className="modalTarjetaNoAgregada">
                {title &&
                    <div className="boxTextos">
                        <h4>{title}</h4>
                    </div>
                }

                <div className="contBtnsEnterado">
                    <div className="bodyModal">
                        <p>{body}</p>

                        {subBody && <p>{subBody}</p>}
                    </div>

                    <div className="contBtns">
                        <div className="btnBlanco" onClick={recapacitar}>Cancelar</div>
                        <div className="btnContinuar2" onClick={elimiar}>SI, Eliminar</div>
                    </div>
                </div>
            </div>

        </>
    )
}

export function ModalTarjetaExpress(props) {
    const {
        remvoeAction,
        awaitAction,
        title,
        body
    } = props;

    const elimiar = () => remvoeAction(true)

    const recapacitar = () => awaitAction(true)

    return (
        <>
            <div className="modalTarjetaNoAgregada">
                {title &&
                    <div className="boxTextos">
                        <h4>{title}</h4>
                    </div>
                }

                <div className="contBtnsEnterado">
                    <div className="bodyModal">
                        <p>{body}</p>
                    </div>
                    <div className="btnContinuar" onClick={remvoeAction}>Volver a intentar</div>
                </div>
            </div>

        </>
    )
}

export function ModalTarjetaDigital(props) {
    const {
        remvoeAction,
        awaitAction,
        title,
        body,
        subBody
    } = props;

    const elimiar = () => remvoeAction(true)

    const recapacitar = () => awaitAction(true)

    return (
        <>
            <div className="modalTarjetaNoAgregada">
                {title &&
                    <div className="boxTextos">
                        <h4>{title}</h4>
                    </div>
                }

                <div className="contBtnsEnterado">
                    <div className="bodyModal">
                        {body && <p>{body}</p>}

                        {subBody && <p>{subBody}</p>}
                    </div>

                    <div className="btnContinuar" onClick={remvoeAction}>Entendido</div>
                </div>
            </div>
        </>
    )
}
